import { HttpResponse } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertDialogData } from 'src/app/classes/alert';
import { AlertService } from 'src/app/services/alert.service';
import { LoggerService } from 'src/app/services/logger.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  standalone: false,
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {
  constructor(
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: AlertDialogData,
    private dialogRef: MatDialogRef<AlertDialogComponent>,
    private logger: LoggerService,
    private toastService: ToastService) {}

  onConfirmClick(): void {
   this.alertService.acknowledgeAlert(this.data.id)
   .subscribe((resp:HttpResponse<any>) => {
      this.logger.debug(`PUT unassign task response:`, resp, 'http');
      if(resp.status === 200){
        this.logger.debug(`PUT Alert acknowledged:`, resp, 'http');
        this.dialogRef.close(true);
      }else{
        this.toastService.show(`HTTP Error: ${resp.status} occurred`, { classname: 'bg-danger text-light', delay: 3000 });
      }
   });
  }

}
